import "./styles.css";

import CTAWpp from "../../components/CTAWpp";

import header2 from "../../assets/header2.png";
import icons from "../../assets/icons.png";

const Header = () => {
  return (
    <header id="header">
      <section className="header1">
        <article className="container">
          <CTAWpp />
        </article>
      </section>

      <section className="header2">
        <article className="container">
          <div className="top">
            <div className="left">
              <h1 className="title">PACOTE EXCLUSIVO</h1>
              <p className="subtitle">
                IDEAL PARA PEQUENAS EMPRESAS OU PROFISSIONAIS
                AUTÔNOMOS/EMPREENDEDORES
              </p>

              <figure>
                <img src={icons} alt="Ícones de redes sociais" />
              </figure>

              <div className="left_text">
                <p className="textlight">Apenas</p>
                <p className="text">R$ 500,00/mês*</p>
                <p className="textlight">sem contrato</p>
              </div>

              <p className="little">
                * Para investimentos de até R$ 2.000,00/mês em campanha por
                mídia (valor pago ao Google, Facebook, Instagram, WhatsApp ou
                Ticktok).
              </p>
            </div>

            <div className="right">
              <figure>
                <img
                  src={header2}
                  alt="Imagens sobre carreira, up nas vendas, etc."
                />
              </figure>

              <div className="mobile">
                <div className="left_text">
                  <p className="textlight">Apenas</p>
                  <p className="text">R$ 250,00/mês</p>
                  <p className="textlight">sem contrato</p>
                </div>

                <p className="little">
                  Para investimento até R$ 1.000,00/mês em campanha (valor pago
                  ao Google, Facebook, Instagram, WhatsApp ou Ticktok).
                </p>

                <p className="price">Pague com cartão, boleto ou pix</p>
              </div>
            </div>
          </div>

          <div className="bottom">
            <CTAWpp />
          </div>
        </article>
      </section>
    </header>
  );
};

export default Header;
